var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A89A6",
    fillRule: "evenodd",
    d: "M12.917 4.167a.833.833 0 0 0-.654.317L11.855 5H6.904a2 2 0 0 0-1.664.89l-.61.916H3.333a.833.833 0 0 0-.833.833v8.194c0 .46.373.834.833.834h13.334c.46 0 .833-.373.833-.834V5a.833.833 0 0 0-.833-.833h-3.75Zm-1.43 3.988 1.833-2.322h2.513V15H4.167V8.472h6.666a.833.833 0 0 0 .654-.317Z",
    clipRule: "evenodd"
  })));
};
export default SvgFolder;